//
// Copyright (c) 2021 Astute Global, Inc.
//

import { Plugin } from "ckeditor5";
import ResponseAttributeEditing from "./responseAttributeEditing";
import ResponseAttributeUi from "./responseAttributeUi";

export default class ResponseAttribute extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  static get requires() {
    return [ResponseAttributeEditing, ResponseAttributeUi];
  }

  // noinspection JSUnusedGlobalSymbols
  static get pluginName() {
    return "ResponseAttribute";
  }
}
